import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  DntEventsListActionTypes,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/store/dnt-events-list.actions';
import { tap } from 'rxjs';
import {
  DntEventsListConstantsModel,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/models/dnt-events-list-constants.model';

@Injectable({ providedIn: 'root' })
export class DntEventsListEffects {
  private actions$ = inject(Actions);

  resetFilters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DntEventsListActionTypes.ResetFilters),
      tap(_ => localStorage.removeItem(DntEventsListConstantsModel.filterKey)),
    );
  }, { dispatch: false });
}
